import * as amplitude from '@amplitude/analytics-react-native';
import Constants from 'expo-constants';
import { AMPLITUDE_KEY, getChannel } from '../../config/config';
import { SEND_TRACKING_INFO } from '../../state/queries/Analytics';
import { client } from '../../config/apollo/client';
import { isWeb } from '../../config/designSystem/Layout';


export const logAmplitude = (event: string, params?: any) : void  => {
  if (!isWeb) {
    if(params) {
      amplitude.track(event, params);
    } else {
      amplitude.track(event);
    }
  } else {
    if(params) {
      client.query({ query: SEND_TRACKING_INFO , variables: {
        eventName: event,
        eventProperties: JSON.stringify(params)
      }, fetchPolicy: 'no-cache'});
    } else {
      client.query({ query: SEND_TRACKING_INFO , variables: {
        eventName: event,
        eventProperties: JSON.stringify(null)
      }, fetchPolicy: 'no-cache'});
    }
  }
};

export const amplitudeInit = async (): Promise<void> => {
  if (!isWeb) {
    await amplitude.init(AMPLITUDE_KEY);
    await setProperty({
      channel : getChannel(),
      runtimeVersion: Constants?.expoConfig?.runtimeVersion });
  }
};

export const setProperty = async (properties: any): Promise<void> => {
  if (!isWeb) {
    const identifyObj = new amplitude.Identify();
    Object.keys(properties).forEach(prop => {
      identifyObj.set(prop,properties[prop]);
    });
    await amplitude.identify(identifyObj);
  }
};

export const setId = async (id: string): Promise<void> => {
  if (!isWeb) {
    await amplitude.setUserId(id);
  }
};